/*
 * @Author: Gang Jiang 
 * @Date: 2025-02-18 16:47:36 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-03-04 09:48:03
 */
<template>
  <div class="help" ref="zjdgx">
    <div class="logo">
      <a href="/">
      <img src="../../../assets/images/img/artemisads-logo.svg" />
      </a>
      <a href="/">{{ st('payResult.backToArtemisAds') }}<i class="iconfont icon-tuichu" /></a>
    </div>
    <div class="content-wrapper">
      <Nav />
      <div class="content">
        <router-view />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script setup>
import Nav from './nav.vue'
import Footer from '~/pages/home/footerComponent.vue'
import { useSellerI18n } from '@/composables/useSellerI18n'

const { st } = useSellerI18n()
</script>

<style lang="less" scoped>
.help {
  background: #f4f2f7;
  .logo {
    display: flex;
    align-items: center;
    padding: 15px 44px 15px 72px;
    justify-content: space-between;
    > a {
      font-size: 14px;
      font-weight: 500;
      color: var(--dark-1);
      &:hover {
        color: var(--dark-3);
      }
      > .iconfont {
        margin-left: 10px;
      }
    }
  }
  .content-wrapper {
    display: flex;
    background: #fff;
    padding-right: 248px;
    min-height: calc(100% - 70px);
  }
  .content {
    margin-top: 1px;
    overflow-y: auto;
    padding-left: 40px;
    min-height: calc(100% - 48px);
  }
  :deep(.breadcrumbs) {
    padding-top: 24px;
    line-height: 16px;
    .iconBread {
      margin-right: 4px;
    }
    a {
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      color: var(--dark-3);
      letter-spacing: 0.3px;
      text-decoration: none;
      &:last-of-type {
        color: var(--dark-2);
      }
      &:hover {
        color: var(--dark-1);
        background-color: var(--color-white);
      }
      &:active {
        opacity: 1;
        font-weight: 500;
        background-color: var(--bg-gray-4);
      }
    }
  }
  :deep(.help-page) {
    .docs {
      font-size: 16px;
      max-width: 1360px;
      color: var(--dark-1);
      padding-bottom: 100px;
      font-family: Sora, sans-serif;
      .ant-table {
        margin-top: 32px;
      }
      a {
        text-decoration: underline;
      }
      > h1 {
        font-weight: 600;
        line-height: 44px;
        margin-bottom: 24px;
        color: var(--dark-1);
        padding: 36px 0 24px;
        letter-spacing: 0.53px;
        border-bottom: 1px solid var(--border-4);
      }
      > h2 {
        font-size: 24px;
        line-height: 38px;
        margin-bottom: 12px;
        letter-spacing: 0.4px;
        &:not(:first-of-type) {
          margin-top: 40px;
        }
      }
      > h3 {
        font-size: 24px;
        margin-top: 20px;
        margin-bottom: 15px;
      }
      > h4 {
        font-size: 18px;
        margin-top: 20px;
        margin-bottom: 15px;
      }
      > img {
        margin: 32px auto;
        display: block;
        border-radius: 4px;
        border: 1px solid var(--border-4);
      }
      > ul, > ol {
        > li {
          font-size: 16px;
          margin-top: 10px;
          line-height: 24px;
          margin-bottom: 10px;
          color: var(--dark-2);
          letter-spacing: 0.4px;
          > ul, > ol {
            > li {
              font-size: 16px;
              margin-top: 10px;
              line-height: 24px;
              margin-bottom: 10px;
            }
          }
        }
      }
      > p {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        margin-bottom: 16px;
        color: var(--dark-2);
        letter-spacing: 0.4px;
      }
      .fw500 {
        font-weight: 500;
      }
      .fw600 {
        font-weight: 600;
        color: var(--dark-1);
      }
    }
  }
}
</style>